/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Ui_Data_Last_UpdatedInputs */

const en_ui_data_last_updated = /** @type {(inputs: Ui_Data_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated ${i?.date}`)
};

const de_ui_data_last_updated = /** @type {(inputs: Ui_Data_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last updated {date}" |
*
* @param {Ui_Data_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_last_updated = /** @type {((inputs: Ui_Data_Last_UpdatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Last_UpdatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_last_updated(inputs)
	return de_ui_data_last_updated(inputs)
});